<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Appointment } from '../../../modules/schedulerApi/appointments/appointment'
    import type { AppointmentItem } from '../../../modules/schedulerApi/appointments/appointment-item'
    import { AppointmentStatus, AppointmentStatusFriendly } from '../../../modules/schedulerApi/appointments/appointments.enum'
    import LoadSpinner from '../../_common/load-spinner.svelte'

    // só os status com rótulo amigável entram como coluna — excluído/bloqueado/disponível não representam um atendimento real
    const STATUS_ORDER = Object.keys(AppointmentStatusFriendly) as AppointmentStatus[]
    // rótulos curtos pra caber no cabeçalho da coluna (o resto vem de AppointmentStatusFriendly)
    const STATUS_LABELS: Record<string, string> = {
        ...AppointmentStatusFriendly,
        agendamento_cancelado_usuario: 'Cancelado cli',
        agendamento_cancelado_empresa: 'Cancelado empr.',
        agendamento_remarcado: 'Remarcado não desc.',
        agendamento_remarcado_descontar: 'Remarcado desc.',
    }

    interface ServiceRow {
        name: string
        counts: Record<string, number>
        total: number
    }

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        const data: Appointment[] = await window.api.schedulers.appointments.getAll({ from, to })
        const pairs: { item: AppointmentItem; status: AppointmentStatus }[] = []
        for (const appointment of data) {
            if (!STATUS_ORDER.includes(appointment.status)) continue
            for (const item of appointment.items || []) {
                pairs.push({ item, status: appointment.status })
            }
        }
        await window.api.utils.utils.assignServicesFromObject(pairs.map((p) => p.item))
        console.log('relat.pairs', pairs)
        loadGrid(pairs)
        show = false
    }

    function loadGrid(pairs: { item: AppointmentItem; status: AppointmentStatus }[]) {
        const grouped = new Map<string, ServiceRow>()
        for (const { item, status } of pairs) {
            const key = item.serviceId || '-'
            let acc = grouped.get(key)
            if (!acc) {
                acc = { name: item.service?.name || '[sem serviço]', counts: {}, total: 0 }
                grouped.set(key, acc)
            }
            acc.counts[status] = (acc.counts[status] || 0) + 1
            acc.total++
        }

        grid = new GridClass()
        grid.title = 'Atendimentos por serviço'
        grid.showFilter = false
        grid.cols.push(new GridCol({ content: 'Serviço' }))
        for (const status of STATUS_ORDER) {
            grid.cols.push(new GridCol({ content: STATUS_LABELS[status], type: GridColTypeEnum.int, showTotal: true }))
        }
        grid.cols.push(new GridCol({ content: 'Total', type: GridColTypeEnum.int, showTotal: true }))

        const rows = [...grouped.values()].filter((row) => row.total !== 0).sort((a, b) => a.name.localeCompare(b.name))
        for (const row of rows) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: row.name })
            for (const status of STATUS_ORDER) {
                line.slots.push({ content: row.counts[status] || 0 })
            }
            line.slots.push({ content: row.total })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
